import {
  Spinner,
  Button,
  Card,
  Text,
  tokens,
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogContent,
  DialogActions,
} from '@fluentui/react-components';
import { PersonRegular } from '@fluentui/react-icons';
import type { MatchDialogProps } from './types';

export default function MatchDialog({
  open,
  onOpenChange,
  selectedChecklist,
  matchCandidates,
  candidatesLoading,
  matchMutation,
}: MatchDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(_, data) => onOpenChange(data.open)}>
      <DialogSurface style={{ maxWidth: '500px' }}>
        <DialogBody>
          <DialogTitle>Match to Client</DialogTitle>
          <DialogContent>
            {selectedChecklist && (
              <div>
                <Text as="p" style={{ marginBottom: '16px' }}>
                  Match "<strong>{selectedChecklist.extractedClientInfo?.name}</strong>" to a client in Dataverse:
                </Text>

                {candidatesLoading ? (
                  <div style={{ display: 'flex', justifyContent: 'center', padding: '24px' }}>
                    <Spinner />
                  </div>
                ) : matchCandidates && matchCandidates.length > 0 ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {matchCandidates.map((candidate) => (
                      <Card
                        key={candidate.contactId}
                        style={{ padding: '12px', cursor: 'pointer' }}
                        onClick={() => {
                          matchMutation.mutate({
                            checklistId: selectedChecklist.id,
                            clientId: candidate.contactId,
                          });
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <PersonRegular style={{ fontSize: tokens.fontSizeBase600 }} />
                          <div>
                            <Text weight="semibold">{candidate.fullName}</Text>
                            {candidate.email && (
                              <Text as="p" size={200} style={{ color: tokens.colorNeutralForeground3 }}>
                                {candidate.email}
                              </Text>
                            )}
                          </div>
                        </div>
                      </Card>
                    ))}
                  </div>
                ) : (
                  <Text style={{ color: tokens.colorNeutralForeground3 }}>
                    No matching clients found. You can search for a client manually.
                  </Text>
                )}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
